// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var NpsLabel$ReactHooksTemplate = require("./NpsLabel.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var NpsRepresentationConfig$ReactHooksTemplate = require("./NpsRepresentationConfig.res.js");

function NpsRoundedBoxForm$NpsItem(props) {
  var onSelection = props.onSelection;
  var step = props.step;
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("span", {
                          children: String(step)
                        })
                  }),
              className: props.className,
              style: props.style,
              onClick: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onSelection, step);
                })
            });
}

var NpsItem = {
  make: NpsRoundedBoxForm$NpsItem
};

function colorBasedOnLikelyness(scale, index) {
  if (scale === "FiveScale") {
    switch (index) {
      case 0 :
      case 1 :
      case 2 :
      case 3 :
          return "#E60000";
      case 4 :
          return "#F79406";
      case 5 :
          return "#21AD04";
      default:
        return "#ffffff";
    }
  } else {
    switch (index) {
      case 0 :
      case 1 :
      case 2 :
      case 3 :
      case 4 :
      case 5 :
      case 6 :
          return "#E60000";
      case 7 :
      case 8 :
          return "#F79406";
      case 9 :
      case 10 :
          return "#21AD04";
      default:
        return "#ffffff";
    }
  }
}

function getConfigString(json, key) {
  var d = Json_decode.optional((function (param) {
          return Json_decode.dict(Json_decode.string, param);
        }), json);
  if (d !== undefined) {
    return Js_dict.get(d, key);
  }
  
}

function normalizeConfiguration(config) {
  if (config === undefined) {
    return ;
  }
  var match = Js_json.decodeObject(config);
  if (match !== undefined) {
    return config;
  }
  var s = Js_json.decodeString(config);
  if (s === undefined) {
    return ;
  }
  try {
    var parsed = JSON.parse(s);
    var match$1 = Js_json.decodeObject(parsed);
    if (match$1 !== undefined) {
      return parsed;
    } else {
      return ;
    }
  }
  catch (exn){
    return ;
  }
}

function NpsRoundedBoxForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var contentOnly = props.contentOnly;
  var configuration = props.configuration;
  var overrideQuestionBlock = props.overrideQuestionBlock;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var nps = props.nps;
  var steps = function (count) {
    return Belt_List.makeBy(count, (function (x) {
                  if (Nps$ReactHooksTemplate.includeZero(nps)) {
                    return x;
                  } else {
                    return x + 1 | 0;
                  }
                }));
  };
  var scale = Nps$ReactHooksTemplate.scale(nps);
  var includeZero = Nps$ReactHooksTemplate.includeZero(nps);
  var configForCategories = normalizeConfiguration(configuration);
  var scaleString = NpsRepresentationConfig$ReactHooksTemplate.scaleStringFromNps(scale, includeZero);
  var categoryRanges = NpsRepresentationConfig$ReactHooksTemplate.getCategoryRangesFromConfig(configForCategories, scaleString);
  var categoryColors = NpsRepresentationConfig$ReactHooksTemplate.getCategoryColorsFromConfig(configForCategories);
  var colorForStep = function (v) {
    return NpsRepresentationConfig$ReactHooksTemplate.colorForStepValue(scaleString, v, categoryRanges, categoryColors);
  };
  var widthAndHeight;
  widthAndHeight = scale === "FiveScale" ? "small:w-8 small:h-8 w-16 h-16" : "small:w-6 small:h-6 w-12 h-12";
  var normalCss = " small:rounded rounded-xl focus:outline-none\n    text-white small:text-sm text-lg font-medium " + widthAndHeight + " ";
  var baseContainerGap;
  baseContainerGap = scale === "FiveScale" ? " small:gap-2 gap-6" : " small:gap-1 gap-2";
  var containerGap;
  if (configuration !== undefined) {
    var match = getConfigString(configuration, "layout");
    containerGap = match === "compact" ? " gap-2 small:gap-1" : baseContainerGap;
  } else {
    containerGap = baseContainerGap;
  }
  var startRating = includeZero ? 0 : 1;
  var endRating;
  endRating = scale === "FiveScale" ? 5 : 10;
  var labelPadding;
  labelPadding = scale === "FiveScale" ? "lg:px-16" : "";
  var selectedCss = function (x) {
    if (Nps$ReactHooksTemplate.isAnswer(nps, x)) {
      return "border-2 border-bleudefrance";
    } else {
      return "";
    }
  };
  var rmName = CustomerInfo$ReactHooksTemplate.rmName(props.customerInfo);
  var questionText = Nps$ReactHooksTemplate.getTextTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)).replace("${RM_NAME}", rmName);
  var items = function (a, b) {
    return $$Array.of_list(Belt_List.mapWithIndex(steps((b - a | 0) + 1 | 0), (function (i, x) {
                      return JsxRuntime.jsx(NpsRoundedBoxForm$NpsItem, {
                                  step: includeZero ? x + a | 0 : (x + a | 0) - 1 | 0,
                                  className: selectedCss(x) + (" " + normalCss),
                                  onSelection: (function (scale) {
                                      Curry._1(onChange, Nps$ReactHooksTemplate.setAnswer(nps, scale));
                                    }),
                                  style: {
                                    backgroundColor: colorForStep(x)
                                  }
                                }, String(i + a | 0));
                    })));
  };
  var questionBlock;
  if (overrideQuestionBlock !== undefined) {
    questionBlock = Caml_option.valFromOption(overrideQuestionBlock);
  } else {
    var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(questionText, substitutionVariables) + (
      mandatory ? " *" : ""
    );
    var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(Nps$ReactHooksTemplate.getDescriptionTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)), substitutionVariables);
    questionBlock = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                  dangerouslySetInnerHTML: {
                    __html: titleHtml
                  }
                }),
            JsxRuntime.jsx("div", {
                  className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                  dangerouslySetInnerHTML: {
                    __html: descriptionHtml
                  }
                })
          ]
        });
  }
  var tmp;
  tmp = scale === "FiveScale" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("p", {
          children: NpsLabel$ReactHooksTemplate.center(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language))),
          className: "pl-12"
        });
  var scaleBody = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: items(startRating, endRating),
                      className: "flex w-full justify-center " + containerGap + " "
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                            }),
                        tmp,
                        JsxRuntime.jsx("p", {
                              children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                            })
                      ],
                      className: " flex justify-between w-full pt-6 pb-10 text-spanishgray text-sm " + labelPadding + " "
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex flex-col w-full"
            }),
        className: "flex w-full"
      });
  if (contentOnly !== undefined && contentOnly) {
    var tmp$1;
    tmp$1 = scale === "FiveScale" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("p", {
            children: NpsLabel$ReactHooksTemplate.center(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language))),
            className: "pl-12"
          });
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: items(startRating, endRating),
                              className: "flex w-full justify-center " + containerGap + " "
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                    }),
                                tmp$1,
                                JsxRuntime.jsx("p", {
                                      children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                    })
                              ],
                              className: " flex justify-between w-full pt-6 pb-10 text-spanishgray text-sm " + labelPadding + " "
                            })
                      ],
                      className: "flex flex-col w-full"
                    }),
                className: "flex w-full"
              });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: questionBlock
                    }),
                scaleBody
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = NpsRoundedBoxForm;

exports.NpsItem = NpsItem;
exports.colorBasedOnLikelyness = colorBasedOnLikelyness;
exports.getConfigString = getConfigString;
exports.normalizeConfiguration = normalizeConfiguration;
exports.make = make;
/* react/jsx-runtime Not a pure module */
